<template>
  <div>
    <div class="cn-button-inner" :class="[`cn-button-inner--${variant}`]">
      <UiIcon v-if="icon" :name="icon" class="cn-button-inner__icon"></UiIcon>
      <span class="cn-button-inner__label">
        <slot />
      </span>
    </div>
    <div
      class="cn-button__backing"
      :class="[`cn-button__backing--${variant}`]"
    ></div>
  </div>
</template>

<script setup lang="ts">
import UiIcon from '@/components/ui/UiIcon';
import type { ButtonVariant } from './UiButton.vue';

interface Props {
  icon?: string;
  variant: ButtonVariant;
}

defineProps<Props>();
</script>

<style lang="scss">
.cn-button-inner {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.625rem 2.25rem;
  letter-spacing: 0.025em;
  transition: transform 150ms ease-in;

  &__icon {
    margin-right: calc(var(--size-base) / 2);
    margin-left: calc(var(--size-base) / 2 * -1);
    width: var(--size-lg);
    height: var(--size-lg);
  }
  .cn-button-inner {
    &__label {
      @media (min-width: 640px) {
        font-size: 1.125rem;
        line-height: 1.75rem;
      }
    }
  }
  &--gray {
    background-color: var(--ab-canyon-button-color-bg-neutral);
    color: var(--ab-canyon-button-color-text-light);
  }
  &--red {
    background-color: var(--ab-canyon-button-color-bg-accent);
    color: var(--ab-canyon-button-color-text-light);
  }
  &--aqua {
    background-color: var(--ab-canyon-button-color-bg-accent-aqua);
    color: var(--ab-canyon-button-color-text-dark);
  }
  &--yellow {
    background-color: var(--ab-canyon-button-color-bg-accent-yellow);
    color: var(--ab-canyon-button-color-text-dark);
  }
  &--blue {
    background-color: var(--ab-canyon-button-color-bg-primary);
    color: var(--ab-canyon-button-color-text-light);
  }
  &--red-outlined {
    background-color: var(--ab-canyon-button-color-bg-light);
    color: var(--ab-canyon-button-color-bg-accent);
    border: 1px solid var(--ab-canyon-button-color-bg-accent);
  }
  &--pink {
    background-color: var(--ab-canyon-button-color-bg-accent-pink);
    color: var(--ab-canyon-button-color-text-light);
  }
}

.cn-button {
  &:hover {
    &:not(:disabled) {
      @media (hover: hover) {
        .cn-button-inner {
          transform: translate(-0.25rem, -0.25rem);
        }
      }
    }
  }
  &__backing {
    position: absolute;
    border-width: 1px;
    border-style: solid;
    inset: 0;
    &--gray {
      border-color: var(--ab-canyon-button-color-bg-neutral);
    }
    &--red {
      border-color: var(--ab-canyon-button-color-bg-accent);
    }
    &--aqua {
      border-color: var(--ab-canyon-button-color-bg-accent-aqua);
    }
    &--yellow {
      border-color: var(--ab-canyon-button-color-bg-accent-yellow);
    }
    &--blue {
      border-color: var(--ab-canyon-button-color-bg-primary);
    }
    &--red-outlined {
      border: 1px solid var(--ab-canyon-button-color-bg-accent);
    }
    &--pink {
      border-color: var(--ab-canyon-button-color-bg-accent-pink);
    }
  }
}
</style>
